
let store={}
let setStore = (code,value)=>{
  store[code] = value
}
let getStore = (code)=>{
  return store[code]
}
export {
  setStore,
  getStore
}